// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.login-bg-image {
    object-fit: cover;
    position: fixed;
    width: 2300px;
    height: 100%;
    z-index: -1;
    left: 0;
}

.color-overlay {
    position: fixed;
    left: 0;
    width: 2300px;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
    z-index: -1;
}

.logo-container {
    margin-top: 70px;
    float: right;
}

.login-logo {
    width: 60% !important;
}

.form-container {
    width: 30%;
    /* background-color: #eae8e8; */
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 1.935px 7.76px 79px 0px RGBA(59, 55, 55, 0.51);
    margin: 60px 0 60px 84px;
    padding: 30px 35px;
}

.header-text {
    font-size: 22px;
    color: #000;
    font-weight: 700;
    padding-bottom: 23px;
}

.input-field-container {
    display: flex;
    justify-content: space-between;
}

.sapce-between-field {
    margin-right: 30px !important;
}

.form-field {
    width: 50%;
    margin-bottom: 22px !important;
}

.terms-and-condition-container {
    padding-top: 8px;
    padding-bottom: 24px;
    display: flex;
    align-items: center;
}

.terms-and-condition-checkbox {
    border-color: #9a9a9a;
    height: 15px;
    width: 15px;
    color: #fff;
    margin-right: 9px !important;
}
/* (TICK MARK SHOULD BE IN WHITE AND BACKGROUND-COLOR: #202425)  */

.terms-and-condition-text {
    color: #000;
    font-size: 16px;
}

.underline {
    cursor: pointer;
    border-bottom: 1px solid #000;
}

.signup-button-container {
    display: flex;
    justify-content: center;
}

.signup-button {
    background-color: #202425;
    border: 1px SOLID #0e1010;
    width: 130px;
    height: 33px;
    font-size: 13px;
    color: #fff;
    font-weight: BOLD;
    text-align: CENTER;
    text-transform: UPPERCASE;
    margin: 10px 37px 10px 37px;
    border-radius: 40px;
    cursor: pointer;
}

.signup-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.already-have-account-text {
    margin-top: 10px;
    font-size: 16px;
    color: #000;
    margin-bottom: 30px;
    text-align: center;
}

.already-have-account-text a {
    cursor: pointer;
    color: #000;
    border-bottom: 1px solid #000;
    text-decoration: none;
}

.already-have-account-text a:hover {
    color: #000;
    border-bottom: 1px solid #000;
    text-decoration: none;
}

.signup-using-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.signup-using {
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;
}

.media-icon-container {
    display: flex;
}

.media-icon {
    margin: 8px;
    cursor: pointer;
    border: 5px solid #fff;
    width: 40px;
    height: 40px;
    font-size: 20px;
    color: #fff;
    border-radius: 50%;
    background-color: #2f95d3
    ;
    /* margin: 16px 5px; */
    padding: 6px;
}

.google-style{
    background: #fff;
    color: #000;
}

.media-icon:disabled {
    pointer-events: none;
    opacity: 0.7;
}

@media (max-width: 1200px) {
    .form-container {
        width: 50%;
    }
}

@media (max-width: 1000px) {
    .login-container {
        flex-direction: column;
        align-items: center;
    }

    .logo-container {
        margin-right: 0;
    }

    .form-container {
        margin-left: 0;
    }

    .home-link {
        display: flex;
        justify-content: center;
    }
}

@media (max-width: 900px) {
    .form-container {
        width: 60%;
    }

    .home-link {
        display: flex;
        justify-content: center;
    }
}

@media (max-width: 800px) {
    .form-container {
        width: 70%;
    }
}

@media (max-width: 700px) {
    .form-container {
        width: 80%;
    }

    .home-link {
        display: flex;
        justify-content: center;
    }
}

@media (max-width: 600px) {
    .form-container {
        width: 95%;
    }

    .home-link {
        display: flex;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/auth/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,WAAW;IACX,OAAO;AACX;;AAEA;IACI,eAAe;IACf,OAAO;IACP,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,0DAA0D;IAC1D,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,4BAA4B;AAChC;AACA,kEAAkE;;AAElE;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB;IACA;IACA,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,uBAAuB;IAC3B;AACJ","sourcesContent":[".login-container {\n    z-index: 3;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n}\n\n.login-bg-image {\n    object-fit: cover;\n    position: fixed;\n    width: 2300px;\n    height: 100%;\n    z-index: -1;\n    left: 0;\n}\n\n.color-overlay {\n    position: fixed;\n    left: 0;\n    width: 2300px;\n    height: 100%;\n    background-color: #000;\n    opacity: 0.5;\n    z-index: -1;\n}\n\n.logo-container {\n    margin-top: 70px;\n    float: right;\n}\n\n.login-logo {\n    width: 60% !important;\n}\n\n.form-container {\n    width: 30%;\n    /* background-color: #eae8e8; */\n    background-color: #fff;\n    border-radius: 15px;\n    box-shadow: 1.935px 7.76px 79px 0px RGBA(59, 55, 55, 0.51);\n    margin: 60px 0 60px 84px;\n    padding: 30px 35px;\n}\n\n.header-text {\n    font-size: 22px;\n    color: #000;\n    font-weight: 700;\n    padding-bottom: 23px;\n}\n\n.input-field-container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.sapce-between-field {\n    margin-right: 30px !important;\n}\n\n.form-field {\n    width: 50%;\n    margin-bottom: 22px !important;\n}\n\n.terms-and-condition-container {\n    padding-top: 8px;\n    padding-bottom: 24px;\n    display: flex;\n    align-items: center;\n}\n\n.terms-and-condition-checkbox {\n    border-color: #9a9a9a;\n    height: 15px;\n    width: 15px;\n    color: #fff;\n    margin-right: 9px !important;\n}\n/* (TICK MARK SHOULD BE IN WHITE AND BACKGROUND-COLOR: #202425)  */\n\n.terms-and-condition-text {\n    color: #000;\n    font-size: 16px;\n}\n\n.underline {\n    cursor: pointer;\n    border-bottom: 1px solid #000;\n}\n\n.signup-button-container {\n    display: flex;\n    justify-content: center;\n}\n\n.signup-button {\n    background-color: #202425;\n    border: 1px SOLID #0e1010;\n    width: 130px;\n    height: 33px;\n    font-size: 13px;\n    color: #fff;\n    font-weight: BOLD;\n    text-align: CENTER;\n    text-transform: UPPERCASE;\n    margin: 10px 37px 10px 37px;\n    border-radius: 40px;\n    cursor: pointer;\n}\n\n.signup-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.already-have-account-text {\n    margin-top: 10px;\n    font-size: 16px;\n    color: #000;\n    margin-bottom: 30px;\n    text-align: center;\n}\n\n.already-have-account-text a {\n    cursor: pointer;\n    color: #000;\n    border-bottom: 1px solid #000;\n    text-decoration: none;\n}\n\n.already-have-account-text a:hover {\n    color: #000;\n    border-bottom: 1px solid #000;\n    text-decoration: none;\n}\n\n.signup-using-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.signup-using {\n    font-size: 16px;\n    color: #000;\n    margin-bottom: 10px;\n}\n\n.media-icon-container {\n    display: flex;\n}\n\n.media-icon {\n    margin: 8px;\n    cursor: pointer;\n    border: 5px solid #fff;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    color: #fff;\n    border-radius: 50%;\n    background-color: #2f95d3\n    ;\n    /* margin: 16px 5px; */\n    padding: 6px;\n}\n\n.google-style{\n    background: #fff;\n    color: #000;\n}\n\n.media-icon:disabled {\n    pointer-events: none;\n    opacity: 0.7;\n}\n\n@media (max-width: 1200px) {\n    .form-container {\n        width: 50%;\n    }\n}\n\n@media (max-width: 1000px) {\n    .login-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .logo-container {\n        margin-right: 0;\n    }\n\n    .form-container {\n        margin-left: 0;\n    }\n\n    .home-link {\n        display: flex;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 900px) {\n    .form-container {\n        width: 60%;\n    }\n\n    .home-link {\n        display: flex;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 800px) {\n    .form-container {\n        width: 70%;\n    }\n}\n\n@media (max-width: 700px) {\n    .form-container {\n        width: 80%;\n    }\n\n    .home-link {\n        display: flex;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 600px) {\n    .form-container {\n        width: 95%;\n    }\n\n    .home-link {\n        display: flex;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
